import { memo, useMemo } from 'react';
import { Button, SpaceBetween } from '@amzn/awsui-components-core';

import ContentEngagementModal from '../content-engagement/ContentEngagementModal';
import { MetaDivider } from '../v2-common/MetaDivider';
import { useCustomerInfluenceViewModel } from './CustomerInfluenceViewModel';

/** "Record reuse" button (AWS-internal users only) that opens the engagement modal. */
export const CustomerInfluenceView = memo(function CustomerInfluenceView() {
  const vm = useCustomerInfluenceViewModel();
  // ContentEngagementModal resets its rows whenever the `engagements` prop changes identity, so copy
  // the list only when it changes: a fresh copy on every render wiped what the user was typing each
  // time this view re-rendered while the modal was open.
  const engagements = useMemo(() => [...(vm?.engagements ?? [])], [vm?.engagements]);

  if (!vm || !vm.isVisible) return null;

  return (
    <SpaceBetween direction="horizontal" size="xs" alignItems="center">
      <MetaDivider />
      <Button variant="inline-link" iconName="group" onClick={vm.openModal} loading={vm.isBusy}>
        Record reuse
      </Button>
      {vm.isModalOpen && (
        <ContentEngagementModal
          engagements={engagements}
          visible
          loading={vm.isBusy}
          errorMessage={vm.errorMessage}
          canSave={vm.isSaveEnabled}
          onCancel={vm.closeModal}
          onUpdate={vm.saveEngagements}
        />
      )}
    </SpaceBetween>
  );
});
